import Marquee from "react-fast-marquee";

const items = [
  "GESTIÓN DE RECURSOS HUMANOS",
  "ASESORÍA LEGAL LABORAL",
  "CONTABILIDAD CORPORATIVA",
  "CUMPLIMIENTO TRIBUTARIO",
  "DESARROLLO ORGANIZACIONAL",
];

export const MarqueeStrip = () => {
  return (
    <div className="border-y border-white/10 bg-vnavy-800 py-6 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-serif text-2xl sm:text-3xl text-white/25 tracking-wide px-8">{t}</span>
            <span className="text-vteal-light/40 text-2xl">•</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
